import lodashMemoize from 'lodash/memoize';

const memoize = (fn) => lodashMemoize(fn, (...args) => JSON.stringify(args));

export default memoize;
